import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { requests } from "../../utils/api/api.service";
import { GROUPS_URL } from "../../utils/api/endpoints";
import { IGroup, IGroupCreate } from "../../shared/interfaces/group/IGroup";

export const GroupService = {
  getAll: (params: IPagination): Promise<IBaseModel<IGroup[]>> =>
    requests.get(GROUPS_URL, params),
  getSingle: (id: number): Promise<{ data: IGroup }> =>
    requests.get(`${GROUPS_URL}/${id}`),
  create: (payload: IGroupCreate): Promise<IGroup> =>
    requests.post(GROUPS_URL, payload),
  update: (payload: IGroupCreate, id: number): Promise<IGroup> =>
    requests.put(`${GROUPS_URL}/${id}`, payload),
  delete: (id: number): Promise<void> =>
    requests.delete(`${GROUPS_URL}/${id}`),
};
